function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 16a3.067 3.067 0 011.04-2.305L21.909.614a2.462 2.462 0 013.252 3.698L12.158 15.751a.334.334 0 000 .501l13.003 11.439a2.462 2.462 0 11-3.251 3.697L7.046 18.311a3.075 3.075 0 01-1.045-2.309z"
});

function SvgArrowLeft1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default SvgArrowLeft1;